import styled from 'styled-components';
import { vars } from '$util/theme';

export const Styled = styled.div`
  position: relative;

  .SearchInput {
    .search-icon > .Image:last-child {
      display: none !important;
    }
    &.react-autosuggest__input--focused {
      .search-icon > .Image:first-child {
        display: none !important;
      }
      .search-icon > .Image:last-child {
        display: initial !important;
      }
    }
  }

  .SuggestionsContainer {
    position: absolute;
    z-index: 2;
    width: 100%;
    max-height: 310px;
    box-shadow: 0 5px 26px 0 rgb(50 56 62 / 16%);
    > ul > li {
      border-bottom: 1px solid ${vars.quantumverse.reskinColors.neutral200};
      &:last-child {
        border-bottom: none;
      }
    }
  }
`;
